export const LIST = "REBATE_SETTING_LIST";
export const UPDATE_STATUS = "REBATE_SETTING_UPDATE_STATUS";
export const DETAILS = "REBATE_SETTING_DETAILS";
export const UPDATE_SETTING = "REBATE_SETTING_UPDATE_SETTING";
